
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import { SCRN_DASHBOARD } from 'src/constants/screens';

const dashBoard = {
    title: 'Dashbooard',
    icon: <DynamicFeedIcon />,
    to:SCRN_DASHBOARD
}

export default [dashBoard]